var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'LegoCardProcess', params: { process: 'Adjuntos', cardId: _vm.card.id }}}},[_c('LegoBtn',[_c('span',[_c('i',{staticClass:"fa-solid fa-paperclip"})]),_vm._v(" Adjuntos ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }